import { useTheme } from 'styled-components';

export const useLeftNavigationTheme = () => {
  const theme = useTheme();
  const { leftNavigation } = theme.components;
  return {
    isDarkBgColorVariant: leftNavigation.bgColorVariant === 'DARK',
    ...leftNavigation,
  };
};
